"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgContext = void 0;
var react_1 = __importDefault(require("react"));
exports.OrgContext = react_1.default.createContext({
    organization: {},
    setCurrentOrganization: function () {
    },
});
